// ABOUTME: Creates reusable WhatsApp application flow models.
// ABOUTME: Reuses the WhatsApp application flow editor without job-link configuration.
import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { useTranslation } from "react-i18next";
import { navigate } from "@gatsbyjs/reach-router";
import WhatsappApplicationPanel from "Pages/Job/JobView/JobShare/WhatsappApplication/WhatsappApplicationPanel";
import {
    getWhatsappApplicationModelScopeFromSearch,
    WhatsappApplicationFlow
} from "Pages/Job/JobView/JobShare/WhatsappApplication/helpers";

const WhatsappApplicationFlowModelNew = () => {
    const [t, i18n, readyTranslation] = useTranslation("JOBSHAREMODULE", {
        useSuspense: false
    });
    const modelScope = getWhatsappApplicationModelScopeFromSearch(
        window.location.search
    );
    const openPersistedModel = React.useCallback((flow: WhatsappApplicationFlow) => {
        const modelId = String(flow?.modelId || "");
        if (!modelId) {
            return;
        }
        navigate(`/whatsappapplicationflowmodel/edit/${modelId}`);
    }, []);

    if (!readyTranslation) {
        return <Page><Loading /></Page>;
    }

    return (
        <Page
            featureName={t("whatsappApplicationModelNewTitle")}
            featureMainDescription={t("whatsappApplicationModelDescription")}
            maxWidth="lg"
        >
            <WhatsappApplicationPanel
                t={t}
                configurationScope="model"
                modelScope={modelScope}
                jobTitle={t("whatsappApplicationModelDefaultName")}
                onModelSaved={openPersistedModel}
            />
        </Page>
    );
};

export default WhatsappApplicationFlowModelNew;
